import { FaHouse, FaMessage, FaBrain, FaChartArea, FaPlus } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";

function BottomMenu() {
  const location = useLocation();

  // Функція для перевірки активного шляху
  const isActive = (path) => location.pathname === path;

  return (
    <div className="flex py-4 px-2 bg-gray-950 -mx-4 rounded-t-[36px] gap-x-3 justify-around items-center">
      <Link to="/">
        <div
          className={`p-3 ${isActive("/") ? "bg-emerald-600 rounded-full" : ""}`}
        >
          <FaHouse className="w-6 h-6" />
        </div>
      </Link>
      <Link to="/ai-psychologist">
        <div
          className={`p-3 ${isActive("/ai-psychologist") ? "bg-emerald-600 rounded-full" : ""}`}
        >
          <FaMessage className="w-6 h-6" />
        </div>
      </Link>
      <Link to="/mood-menu">
        <div
          className={`p-3 ${isActive("/mood-menu") ? "bg-emerald-600 rounded-full" : ""} rounded-full bg-gradient-to-tr from-emerald-500 via-cyan-500 to-emerald-500 bg-gradient-size animate-gradient-move`}
        >
          <FaPlus className="w-8 h-8" />
        </div>
      </Link>
      <Link to="/ai-analysis">
        <div
          className={`p-3 ${isActive("/ai-analysis") ? "bg-emerald-600 rounded-full" : ""}`}
        >
          <FaBrain className="w-6 h-6" />
        </div>
      </Link>
      <Link to="/statistics">
        <div
          className={`p-3 ${isActive("/statistics") ? "bg-emerald-600 rounded-full" : ""}`}
        >
          <FaChartArea className="w-6 h-6" />
        </div>
      </Link>
    </div>
  );
}

export default BottomMenu;
